export default Object.freeze({
  DefaultInitial: 'default-initial',
  CompleteInformation: 'complete-information',
  Approval: 'approval',
  AutoApprove: 'auto-approve',
  Conditional: 'conditional',
  ExecuteTask: 'execute-task',
  ExecuteApiCall: 'execute-api-call',
  AutoReject: 'auto-reject',
  DigitalSignature: 'digital-signature',
  SendEmail: 'send-email',
  ExecuteQuery: 'execute-query',
  DynamicEntityOperation: 'dynamic-entity-operation',
  GenerateExcel: 'generate-excel',
  StartProcessInstance: 'start-process-instance',
  SetVariableData: 'set-variable-data',
  SetFormData: 'set-form-data',
  Parallel: 'parallel',
  GenerateDocuments: 'generate-documents',
  ScheduledExecution: 'scheduled-execution',
  SharePointOperation: 'sharepoint-operation',
  Iterate: 'iterate',
  Switch: 'switch',
  InternalOperation: 'internal-operation',
  GeneratePlainTextFile: 'generate-plain-text-file',
  ImportPlainTextFile: 'import-plain-text-file',
  ConsumeSequence: 'consume-sequence',
  ExecuteRpaFlow: 'execute-rpa-flow',
  Integration: 'integration',
  AutoCancel: 'auto-cancel',
  AutoVoid: 'auto-void',
  OpenAI: 'chat-gpt',
  ExecuteProcessAction: 'execute-process-action',
  GoogleIntegration: 'google-integration',
  RevertCancellation: 'revert-cancellation',
  RevertVoiding: 'revert-voiding',
  FTPOperation: 'ftp-operation',
  RunCode: 'run-code',
  AutomyAI: 'automy-ai',
  WhatsAppBusinessIntegration: 'whatsapp-business-integration',
  MicrosoftTeamsIntegration: 'microsoft-teams-integration',
  WaitForChildRequests: 'wait-for-child-requests',
  SendSMS: 'send-sms',
});
